import { render, staticRenderFns } from "./ChecklistStudentView.vue?vue&type=template&id=5d113122&"
import script from "./ChecklistStudentView.vue?vue&type=script&lang=js&"
export * from "./ChecklistStudentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports